export default {"src":"https://cdn.tanzhi.cn/_next/static/media/chart.154f4c45.svg","height":648,"width":707,"blurWidth":0,"blurHeight":0};